import React, { useState, useEffect } from 'react';
import './GutterComponent.scss'; // Importing the SCSS for styles

interface GutterProps {
    images: string[]; // Array of image URLs
    left: number | string
    top: number | string
}

const GutterComponent: React.FC<GutterProps> = ({ images, left, top }) => {
    const [randomImage, setRandomImage] = useState<string>('');
    const [time, setTime] = useState('');
    const gutterBoxStyle = {
        '--left': left,
        '--top': top
    } as React.CSSProperties;
    useEffect(() => {
        // Function to select a random image
        const selectRandomImage = () => {
            const randomIndex = Math.floor(Math.random() * images.length);
            setRandomImage(images[randomIndex]);
        };

        // Select an initial random image
        selectRandomImage();
        setTime(`${Math.floor(Math.random() * 10 + 10)}s`);
        // Set an interval to change the image
        const interval = setInterval(selectRandomImage, 5000); // Change every 5 seconds

        return () => clearInterval(interval); // Clear interval on component unmount
    }, [images?.length]);

    return (
        <div className="gutter-box" style={gutterBoxStyle}>
            {randomImage && <img src={randomImage} alt="Random" style={{
                ['--time']: time
            }} />}
        </div>
    );
};

export default GutterComponent;
